import type { ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'

export function PjCadastroPanel({ children }: { children: ReactNode }) {
  return (
    <div className='rounded-xl border border-[#dfe1e6] bg-white p-5 shadow-sm sm:p-6 dark:border-white/10 dark:bg-bg-card'>
      {children}
    </div>
  )
}

type FormSectionProps = {
  icon: LucideIcon
  title: string
  description?: string
  children: ReactNode
}

export function PjCadastroFormSection({ icon: Icon, title, description, children }: FormSectionProps) {
  return (
    <section className='rounded-xl border border-[#e8edf5] bg-[#fafbfc] p-4 sm:p-5'>
      <div className='mb-4 flex items-start gap-3'>
        <div className='flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-emerald-600/10 text-emerald-700'>
          <Icon size={18} aria-hidden />
        </div>
        <div className='min-w-0'>
          <h2 className='text-sm font-semibold text-[#172b4d]'>{title}</h2>
          {description ? <p className='mt-0.5 text-xs leading-relaxed text-[#6b778c]'>{description}</p> : null}
        </div>
      </div>
      {children}
    </section>
  )
}

export function PjCadastroSelect({
  label,
  value,
  onChange,
  required,
  children,
}: {
  label: string
  value: string
  onChange: (value: string) => void
  required?: boolean
  children: ReactNode
}) {
  return (
    <div className='flex flex-col gap-1.5'>
      <label className='font-medium uppercase tracking-wider text-[var(--font-color-label)]' style={{ fontSize: 'var(--font-size-label)' }}>
        {label}
      </label>
      <select
        value={value}
        required={required}
        onChange={(e) => onChange(e.target.value)}
        className='w-full rounded-md border border-[var(--glass-border)] bg-[var(--glass-bg)] px-3 py-2 text-[13px] text-[var(--text-primary)] outline-none transition-colors focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600/20'
      >
        {children}
      </select>
    </div>
  )
}
